import React, { useEffect, useState } from 'react'
import { Button, ConfigProvider, Form, Input, message, Modal } from 'antd'
import { PlusOutlined, EditOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { FormButton, SearchWrapper, WhiteWrapper } from './genbiManagement.styled'
import MainTable from '../../components/Basic/MainTable'
import useParams from '../../hook/useParams'
import { useSelector } from 'react-redux'
import { fetchGenbiProfileName } from '../../apis/auth'
import { addGenbiEntity, delGenbiEntity, fetchGenbiEntity } from '../../apis/genbi'

function GenBIEntityManagement (props) {
  const { t: ln_t } = useTranslation()
  const user = useSelector((state) => state.user)
  const { nowBrand } = user || {}
  const params = useParams({ sort: null, maxResults: null, startIndex: null }, false)
  const { handleFetchParams, fetchParams, setReady } = params
  const [form] = Form.useForm()
  const [profileName, setProfileName] = useState()
  const [show, setShow] = useState(false)
  const [editData, setEditData] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const defPlaceholder = (name, type) => {
    const message = type === 'input' ? ln_t('util.pleaseEnter') : type === 'select' ? ln_t('util.pelaseSelect') : ''
    return `${message} ${ln_t(`genbiManagement.${name}`)}`
  }
  const defConfig = (name, type, required = true) => ({
    name, label: ln_t(`genbiManagement.${name}`), rules: [{ required, message: defPlaceholder(name, type) }]
  })

  const handleClose = () => {
    setShow(false)
    form.resetFields()
    setEditData()
  }

  const handleSave = async value => {
    setIsLoading(true)
    const result = await addGenbiEntity(profileName, value)
    if (result?.status !== 200) return setIsLoading(false)
    setTimeout(() => {
      message.success(ln_t(editData ? 'message.success.modify' : 'message.success.create'))
      setIsLoading(false)
      handleClose()
      handleFetchParams('init', {})
    }, 600)
  }

  const handleDelete = (id, data) => {
    Modal.confirm({
      title: `${ln_t('util.delete')} ${ln_t('genbiManagement.metricsEntity')}`,
      content: `${ln_t('message.confirm.delete')} ${data.entity}?`,
      onOk: async () => {
        const result = await delGenbiEntity(profileName, id)
        if (result?.status === 200) {
          setTimeout(() => {
            handleFetchParams('add', {})
            message.success(ln_t('message.success.delete'))
          }, 600)
        }
      }
    })
  }

  const handleEdit = data => {
    setEditData(data)
    form.setFieldsValue(data)
    setShow(true)
  }
  const apiFunc = async () => fetchGenbiEntity(profileName, fetchParams)?.then(res => ({ ...res, data: res?.data?.data }))
  const columns = [
    { title: ln_t('genbiManagement.entity'), dataIndex: 'entity', width: '32px' },
    { title: ln_t('genbiManagement.comment'), dataIndex: 'comment', ellipsis: true },
    {
      title: ln_t('util.action'),
      dataIndex: 'id',
      width: '24px',
      render: (id, data) => (
      <div className="action-btn">
        <Button size="small" icon={<EditOutlined />} onClick={() => handleEdit(data)} />
        <Button size="small" icon={<DeleteOutlined />} onClick={() => handleDelete(id, data)} />
      </div>)
    }
  ]

  const getProfileName = async () => {
    const res = await fetchGenbiProfileName(nowBrand)
    if (res?.status === 200) setProfileName(res?.data?.profileName)
    setReady(true)
  }

  useEffect(() => {
    getProfileName()
  }, [nowBrand])

  return (
    <>
      <WhiteWrapper>
        <h3>{ln_t('sidebar.genBiManagement')}</h3>
        <SearchWrapper>
          <Input.Search
            allowClear
            style={{ width: '400px' }}
            placeholder={ln_t('util.search')}
            onSearch={entity => handleFetchParams('add', { entity: encodeURIComponent(entity) })}
            enterButton={<Button type="primary" size="small" icon={<SearchOutlined />} />}
          />
          <Button type="default" icon={<PlusOutlined />} onClick={() => setShow(true)} style={{ marginLeft: 'auto' }}>
            {ln_t('util.add')} {ln_t('genbiManagement.metricsEntity')}
          </Button>
        </SearchWrapper>

        <MainTable
          columns={columns}
          rowKey="id"
          apiFunc={apiFunc}
          params={params}
          noPage
        />
      </WhiteWrapper>

      <ConfigProvider theme={{ token: { colorPrimary: 'rgb(71, 182, 175)', colorPrimaryHover: 'rgba(71, 182, 175,.8)' } }}>
        <Modal title={`${editData ? ln_t('util.edit') : ln_t('util.add')} ${ln_t('genbiManagement.metricsEntity')}`} open={show} onCancel={handleClose} footer={null}>
          <Form form={form} layout="vertical" requiredMark={false} onFinish={handleSave}>
            <Form.Item {...defConfig('entity', 'input')} style={{ marginTop: '16px' }}>
              <Input placeholder={defPlaceholder('entity', 'input')} disabled={editData} />
            </Form.Item>
            <Form.Item {...defConfig('comment', 'input')} style={{ marginTop: '16px' }}>
              <Input.TextArea placeholder={defPlaceholder('comment', 'input')} style={{ height: 120 }} />
            </Form.Item>
            <FormButton>
              <Button type="default" onClick={handleClose}>{ln_t('util.cancel')}</Button>
              <Button type="primary" htmlType="submit" loading={isLoading}>{ln_t('util.confirm')}</Button>
            </FormButton>
          </Form>
        </Modal>
      </ConfigProvider>
    </>
  )
}

export default GenBIEntityManagement
